import { createAsyncThunk } from '@reduxjs/toolkit';

import { getMismatchedSearchFeed } from '../../utils/api';

export const fetchMismatchedSearchFeed = createAsyncThunk(
  'mismatchedSearchFeed/fetchMismatchedSearchFeed',
  () => getMismatchedSearchFeed(),
);
